/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCourseDateEndLearning } from 'api/courses/courses';
import {
    AssignCourseFormData,
    CreateCourseFormData
} from 'api/courses/courses.types';
import { useCallback, useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import FormField from 'ui/FormField/FormField';
import { OptionsGenerator, SelectField } from 'ui/Select';
import { isoDateWithoutTime } from 'utils/date';
import { getProfessions } from 'api/professions/professions';
import { QueryKey, PROFESSION_STALE_TIME_MS } from 'helpers/constants';

export const Field = FormField<CreateCourseFormData>;
export const Select = SelectField<CreateCourseFormData>;

export const EndDateField = () => {
    const form = useForm<AssignCourseFormData>();

    const {
        values: { dateStartLearning, courseId }
    } = useFormState<AssignCourseFormData>();

    useEffect(() => {
        const fetchDate = async () => {
            if (dateStartLearning && courseId) {
                const newDate = await getCourseDateEndLearning(
                    courseId,
                    dateStartLearning
                );

                form.change('dateEndLearning', isoDateWithoutTime(newDate));
            }
        };

        fetchDate();
    }, [form, dateStartLearning, courseId]);

    return (
        <FormField<AssignCourseFormData>
            name="dateEndLearning"
            label="Дата окончания обучения"
            type="date"
            required
        />
    );
};

type ProfessionFieldProps = {
    titleValues?: boolean;
    name?: string;
};

export const ProfessionField = ({
    titleValues,
    name
}: ProfessionFieldProps) => {
    const onSearch: OptionsGenerator = useCallback(
        async (search?: string) => {
            const professions = await getProfessions(search);
            return professions.map((profession) => ({
                value: titleValues ? profession.title : profession.id,
                label: profession.title
            }));
        },
        [titleValues]
    );

    return (
        <SelectField<any>
            name={
                name ?? ('professionId' satisfies Paths<CreateCourseFormData>)
            }
            label="Название профессии (из справочника)"
            placeholder="Выберите профессию"
            onSearch={onSearch}
            queryKey={[QueryKey.Profession, ...(titleValues ? ['title'] : [])]}
            followOrganization={false}
            staleTimeMs={PROFESSION_STALE_TIME_MS}
        />
    );
};
